import { BRANDID, COOKIE_NAMES, DEFAULT_COOKIE_ACTIVE_DAYS } from './constants';
import { setCookie, getCookieValue } from './cookie';

import {
  onFocus,
  isLeadInfoValid,
  setPhoneFlagAttributes,
  highlightInvalidFields,
  getRefinedLeadInfo,
  processLeadRegistration,
  getSanitizedInput,
  showPlansFold,
} from './utils/registerUtils';

let leadInfo = {};

const registerBtn = document.querySelector('#register');
const isReferAFriendPage = window.location.pathname.includes('redeem-your-referral');


function onBlur(event, info) {
  const userInput = event.target.value;
  if (getSanitizedInput(userInput) !== userInput) {
    event.target.classList.add('invalid');
    leadInfo[info.emittedBy].value = '';
    leadInfo[info.emittedBy].valid = false;
  } else {
    leadInfo[info.emittedBy] = info;
  }
}

leadInfo = window.InputValidator && window.InputValidator.fields.initialize({
  fields: {
    phone: {
      selector: '#phone',
      type: 'phone',
      withDialCodePicker: true,
      country: (window.siteInfo && window.siteInfo.country) || 'GB',
      errorClassName: 'invalid',
    },
    ...(document.getElementById('company') && {
      company: {
        selector: '#company',
        type: 'text',
        errorClassName: 'invalid',
      },
    }),
    mail: { selector: '#email', type: 'email', errorClassName: 'invalid' },
    name: { selector: '#name', type: 'text', errorClassName: 'invalid' },
  },
  eventListeners: {
    blur: onBlur,
    focus: onFocus,
  },
});

const successCallback = (response) => {
  if (response?.isTest === 'true') {
    setCookie(COOKIE_NAMES.IS_TEST_REGISTERED, 'true', DEFAULT_COOKIE_ACTIVE_DAYS);
  }

  window.location.href = '/plans';
};

const failureCallback = () => {
  registerBtn.removeAttribute('style');
  document.getElementById('registration').classList.remove('loading');
};

if (registerBtn) {
  registerBtn.addEventListener('click', () => {
    if (isLeadInfoValid(leadInfo)) {
      registerBtn.setAttribute('style', 'pointer-events: none;cursor: default;');
      document.getElementById('registration').classList.add('loading');
      const payload = getRefinedLeadInfo(leadInfo);
      processLeadRegistration({
        ...payload,
        brandid: BRANDID,
        cookie: document.cookie,
        referrer: document.referrer || window.location.href,
        ...(isReferAFriendPage && {
          reference: 'Referral',
          referrerContactId: getCookieValue('referrerContactId'),
        }),
        isAgreed: true,
        timezone: window.getUserTimezone && window.getUserTimezone(),
      }, successCallback, failureCallback);
    } else if (leadInfo && Object.keys(leadInfo).length) {
      highlightInvalidFields(leadInfo);
    }
  });
}

window.addEventListener('pageshow', (event) => {
  if (getCookieValue('isregistered') && event.persisted) {
    showPlansFold(getCookieValue('uniquePin'));
  }
});

// Intltel Input Accessibility
window.addEventListener('load', () => {
  setPhoneFlagAttributes();
});
